export default function ConsultarFornecedor() {
    return (
        <div>
            <h1>Consultar Fornecedor</h1>
            <p>Esse componente ser usado para consulta/edição de fornecedores</p>
        </div>
    )
}